import { Navigate, Outlet, Route, Routes, useParams } from "react-router-dom";
import { ProjectProvider } from "./context/ProjectContext.jsx";
import ProtectedOutlet from "./components/ProtectedOutlet.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import ToastProvider from "./components/ui/ToastProvider.jsx";
import HomeEntry from "./pages/HomeEntry.jsx";
import Login from "./pages/Login.jsx";
import Recovery from "./pages/Recovery.jsx";
import Settings from "./pages/Settings.jsx";
import SettingsAccountRedirect from "./pages/SettingsAccountRedirect.jsx";
import OrgConnecting from "./pages/OrgConnecting.jsx";
import ProjectWorkspace from "./pages/ProjectWorkspace.jsx";
import ProjectReport from "./pages/ProjectReport.jsx";
import ReportView from "./pages/ReportView.jsx";
import RemediationSummaryView from "./pages/RemediationSummaryView.jsx";

function ProjectShell() {
  const { projectId } = useParams();
  return (
    <ProjectProvider projectId={projectId}>
      <Outlet />
    </ProjectProvider>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
      <Routes>
        <Route path="/" element={<HomeEntry />} />
        <Route path="/login" element={<Login />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/settings/account" element={<SettingsAccountRedirect />} />
        <Route path="/settings" element={<Settings />} />
        <Route element={<ProtectedOutlet />}>
          <Route
            path="/project/:projectId"
            element={
              <ErrorBoundary>
                <ProjectShell />
              </ErrorBoundary>
            }
          >
            <Route path="connect" element={<OrgConnecting />} />
            <Route index element={<ProjectWorkspace />} />
            <Route path="implementation-report" element={<ProjectReport />} />
            <Route path="report" element={<ReportView />} />
            <Route path="report/:snapshotId" element={<ReportView />} />
            <Route path="remediation" element={<RemediationSummaryView />} />
            <Route path="remediation/:snapshotId" element={<RemediationSummaryView />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ToastProvider>
    </ErrorBoundary>
  );
}
